import { render, staticRenderFns } from "./HappyMindInsurance.vue?vue&type=template&id=218af08a"
import script from "./HappyMindInsurance.vue?vue&type=script&lang=js"
export * from "./HappyMindInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports